import { RutValidationResponse } from '../models/http/RutValidation.interface';
import { UserInformation } from '../models/UserInformation.interface';
export const mapper = {
  userInfo: (response: RutValidationResponse): UserInformation => {
    return {
      nombre: response.nombre,
      rut: response.rut,
      email: response.email,
      telefonoCelular: response.telefonoCelular,
      cic: response.cic
    }
  }
}
